import React from 'react';
import Icon from '@hubins/components/IconNew';
import "./index.scss";

interface SelectGroupProps {
  id?: string;
  options: Array<{
    id: string;
    label: string;
    value: string;
    disabled?: boolean;
  }>;
  value: string | string[];
  multiple?: boolean;
  disabled?: boolean;
  onChange: (value: string | string[]) => void;
}

const SelectGroup = ({ id, options, value, disabled = false, multiple = false, onChange }: SelectGroupProps) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    
    if (multiple) {
      const newValue = [...value];

      if (!newValue.includes(val)) {
        newValue.push(val);
      } else {
        newValue.splice(newValue.indexOf(val), 1);
      }

      onChange?.(newValue);
    } else {
      if (value !== val) onChange?.(val);
    }
  };

  return (
    <div
      className={`select-group ${disabled ? 'select-group--disabled' : ''}`}
    >
      {options.map((option) => {
        const isChecked = Array.isArray(value) ? (value as any[]).includes(option.value) : value === option.value;
        const optionId = `select-group-option-${id || ''}-${option.id}`;
        
        return(
          <label className={`select-group__option-wrapper ${isChecked ? 'select-group__option-wrapper--active' : ''} ${option.disabled ? 'select-group__option-wrapper--disabled' : ''}`} key={optionId}>
            <div>
              <input
                id={optionId}
                role={multiple ? "checkbox" : "radio"}
                type={multiple ? "checkbox" : "radio"}
                value={option.value}
                aria-checked={isChecked}
                checked={isChecked}
                className={"select-group__option"}
                onChange={handleOnChange}
              />
              <span className="select-group__option-label">{option.label}</span>
            </div>
            {isChecked && (
              <Icon icon="check signle" size={16} color="primary" />
            )}
          </label>
        )
      }
    )}
    </div>
  );
};

export default SelectGroup;